import api from '../api';
import {
  IGetAllStaffAttendanceQuery,
  ITeacherAttendanceApiResponse,
  IMarkingTeacherAttendancePayload,
  IMarkAttendanceResponse,
  IMarkAbsentOrLeaveResponse,
  IMarkingAbsentOrLeavePayload,
  IMarkingCheckOutPayload,
  IMarkingAbsentPayload,
  IDeleteAttendancePayload,
  IDeleteAttendanceResponse,
} from '../../interface/teacherAttendanceModel';

export const getAllTeacherAttendance = async (
  params: IGetAllStaffAttendanceQuery,
): Promise<ITeacherAttendanceApiResponse> => {
  const response = await api.get<ITeacherAttendanceApiResponse>('/staff-attendance', {
    params,
  });
  return response.data;
};

export const checkInTeacherAttendance = async (
  payload: IMarkingTeacherAttendancePayload,
): Promise<IMarkAttendanceResponse> => {
  const response = await api.post<IMarkAttendanceResponse>('/staff-attendance/check-in', payload);
  return response.data;
};

export const checkOutTeacherAttendance = async (
  payload: IMarkingCheckOutPayload,
): Promise<IMarkAttendanceResponse> => {
  const response = await api.post<IMarkAttendanceResponse>('/staff-attendance/check-out', payload);
  return response.data;
};

// absent api
export const markAbsentTeacherAttendance = async (
  payload: IMarkingAbsentPayload,
): Promise<IMarkAbsentOrLeaveResponse> => {
  const response = await api.post<IMarkAbsentOrLeaveResponse>('/staff-attendance/absent', payload);
  return response.data;
};

// leave api
export const markLeaveTeacherAttendance = async (
  payload: IMarkingAbsentOrLeavePayload,
): Promise<IMarkAbsentOrLeaveResponse> => {
  const response = await api.post<IMarkAbsentOrLeaveResponse>('/staff-attendance/leave', payload);
  return response.data;
};

// delete attendance
export const hardDeleteTeacherAttendance = async (
  payload: IDeleteAttendancePayload,
): Promise<IDeleteAttendanceResponse> => {
  const response = await api.delete<IDeleteAttendanceResponse>('/staff-attendance', {
    data: payload,
  });
  return response.data;
};
